import { EDelegatedPages } from '@Managers/PopClient/UsePopClient.types';

export enum TPopClientFeatures {
    BASIC = 'basic',
    PAUSE = 'pause',
    AUTOPLAY = 'autoplay',
    CLOSEGAME = 'closegame',
    OPEN_PAGE = 'openpage',
    SOUND = 'sound',
    SWITCH_GAME = 'switchgame',
    GAME_CHANGE = 'gamechange',
    SWITCHMODE = 'switchmode',
    LOADING_STATUS = 'loadingstatus',
    ERROR = 'error',
    GAME_ROUND = 'gameround',
    BALANCE_UPDATE = 'balanceupdate',
    BALANCE_REFRESH = 'balancerefresh',
    ACTIONS = 'actions',
    BET_UPDATE = 'betupdate',
    DISPLAY_STATUS = 'displaystatus',
    ERRORS = 'errors'
}

export type TPopClientFeaturesList = {
    [key: string]: undefined | boolean | { delegatePages: EDelegatedPages[] } | { mute: boolean; level: number };
    [TPopClientFeatures.OPEN_PAGE]?: { delegatePages: EDelegatedPages[] };
    [TPopClientFeatures.SOUND]?: { mute: boolean; level: number };
};
export interface IUILayerConfig {
    debugTools?: {
        active: boolean;
        consoleLogger: boolean;
        getGameFixes: boolean;
    };
    demoModeInformation?: boolean;
    gameNamePanel?: boolean;
    timePanel?: boolean;
    wcaMode?: boolean;
    inGameHistory?: boolean;
    buttons: {
        home?: boolean;
        fullScreen?: boolean;
    };
    popClient?: {
        mode: boolean;
        version: string;
        features: TPopClientFeaturesList;
    };
}
